import Spinner from '@core/components/spinner/Spinner';
import Contents from 'components/pages/my-uni/Contents';
import EmptyPage from 'components/pages/my-uni/EmptyPage';
import { useQuery } from 'react-query';
import { GetMyUniContents } from 'services/core';

import { NextSeo } from 'next-seo';
import { getMyUniSeoProps } from 'router/seoprops';

import LoginNotice from 'components/common/loginnotice/LoginNotice';

import classes from './index.module.scss';
import CourseSuggestion from '@core/components/coursesuggestion/CourseSuggestion';

const MyCourses = () => {
	const { data, isLoading, error } = useQuery(['my-uni'], GetMyUniContents);
	const seoProps = getMyUniSeoProps();
	return (
		<>
			<NextSeo {...seoProps} />
			{isLoading && !data && !error ? (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			) : (
				<>
					{data && !error ? (
						<>
							{data &&
								data.data.length !== 0 &&
								data.data.some((item) => item.results.length > 0) ? (
								<div className='container p-lg-0'>
									<Contents data={data.data} />
									<CourseSuggestion type='long' />
								</div>
							) : (
								<div className='d-flex justify-content-center align-items-center h-100'>
									<EmptyPage />
								</div>
							)}
						</>
					) : (
						error.response.status === 401 && (
							<div className="py-5">
								<LoginNotice />
							</div>
						)
					)}
				</>
			)}
		</>
	);
};

export default MyCourses;